import axios from 'axios'
import { API_URL } from '../api.js'

const api = `${API_URL}/users`
// const api = 'http://localhost:5000/api/users'

export default {
    async forgotPassword(email) {
        const resp = await axios.post(`${api}/forgotpassword`, { email })
        return resp.data
    },
    async changePassword(token, password) {
        const resp = await axios.post(`${api}/changepassword`, { token, password })
        return resp.data
    }
}